'use-strict'

import { App } from "../utilities/App";
import { isset } from "../utilities/utilities";

/* COOKIES NOTIFY */
function cookiesNotifyActions() {

	if ( !window.localStorage.getItem('cookiesNotifyTimestamp') || +window.localStorage.getItem('cookiesNotifyTimestamp') < Date.now() )
		$('[js-cookies]').fadeIn(0);
	
	$('[js-cookies-close]').on('click', function(event) {
		event.stopPropagation();
		onClickCloseCookiesNotify();
	});
	
}
function onClickCloseCookiesNotify() {

	$('[js-cookies]').fadeOut(300);

	let timestamp = Date.now() + ( +CFG.cookiesNotifyClosingDays * 24 * 60 * 60 * 1000 );
	// let timestamp = Date.now() + ( 60 * 1000 );
	window.localStorage.setItem('cookiesNotifyTimestamp', timestamp);
	
}

/* ALERT */
function showAlert( alertData, selector ) {
	
	/* alertData structure
	
	alertData = {
		title: '' // plain text or HTML
		body:  '' // plain text or HTML
		buttons: [ // array of strings or objects; every button close alert by default
			'Button Name',
			{
				name: // plain text or HTML
				close: // boolean (optional; default: true; if button close alert)
				action: // function (action after cliking on button, before closing)

				// If no action and close is false button will not be rendered
			}
		]
	}

	*/

	if ( !isset(alertData.title) || !isset(alertData.body) ) return;
	if ( !isset(selector) ) selector = '[js-alert]';
	
	const ALERT = $(selector);

	if ( ALERT.is(':visible') ) return;
	
	ALERT.find('.modal-title').html(alertData.title);
	ALERT.find('.modal-body').html(alertData.body);

	if ( isset(alertData.buttons) && Array.isArray(alertData.buttons) ) {

		let isAnyButton = false;

		ALERT.find('.modal__button').remove();

		for ( const button of alertData.buttons ) {

			if ( typeof button === 'string' ) button = { name: button };

			if ( typeof button === 'object' && isset(button.name) ) {

				if ( !isset(button.close) ) button.close = true;
				
				let buttonTemplate = $(App.templates.modalButton);

				buttonTemplate
					.html(button.name)
					.on('click', () => {
						if ( typeof button.action === 'function' ) button.action();
						if (!!button.close) hideAlert(selector);
					});
				
				if ( typeof button.action === 'function' || !!button.close ) {
					
					ALERT.find('.modal-footer').append(buttonTemplate);
					isAnyButton = true;

				}

			}
			
		}
		
		if ( isAnyButton ) ALERT.find('.modal-footer').fadeIn(0);
		
	} else {

		ALERT.find('.modal__button').remove();
		ALERT.find('.modal-footer').fadeOut(0);

	}
	
	App.disableScroll();
	
	ALERT.fadeIn(300);
	
}
function hideAlert( selector ) {

	if ( !isset(selector) ) selector = '[js-alert]';

	const ALERT = $(selector);

	App.enableScroll();
	
	ALERT.fadeOut(300);
	
}

function alertActions() {

	$(document).on('click', '[js-alert-backdrop], [js-alert-close]', onClickCloseAlert);
	
}

function onClickCloseAlert() {

	hideAlert()
	
}

export {
	cookiesNotifyActions,
	showAlert,
	hideAlert,
	alertActions,
};